/* eslint-disable prettier/prettier */

import { formatEther, parseEther } from 'viem';

import { AllVestaSystemVault, ETroveStatusGraph, SystemVault } from '~components/hooks/protocol/_types';
import { AddressString, TVaultManager, TVestaInterestManager } from '~components/providers/types';
import VestaSubgraph from '~services/subgraph/vesta';
import { GraphUserVault } from '~services/subgraph/vesta/types';

//@TODO change query to get interest rate aswell
export async function getGraphSystemVaults(graph: VestaSubgraph): Promise<AllVestaSystemVault> {
  const vaultInfo = await graph.vaults.getSystemVaultInfo();

  return { vaultInfo };
}

export async function getChainSystemVault({
  assetAddress,
  collatPrice,
  vaultManagerRead,
}: {
  assetAddress: AddressString;
  collatPrice: number;
  vaultManagerRead: TVaultManager['read'];
}): Promise<SystemVault> {
  const [systemCollateral, systemDebt, totalCollateralizationRatio, unpaidInterest] = await Promise.all([
    vaultManagerRead.getEntireSystemColl([assetAddress]),
    vaultManagerRead.getEntireSystemDebt([assetAddress]),
    vaultManagerRead.getTCR([assetAddress, parseEther(collatPrice.toString())]),
    vaultManagerRead.getSystemTotalUnpaidInterest([assetAddress]),
  ]);

  return {
    vaultInfo: {
      currentAssetSystemState: {
        totalCollateral: formatEther(systemCollateral),
        totalCollateralRaw: systemCollateral,
        totalCollateralRatio: formatEther(totalCollateralizationRatio),
        totalDebt: formatEther(systemDebt),
        totalDebtRaw: systemDebt,
        unpaidInterest: formatEther(unpaidInterest),
      },
    },
  };
}

export const findTroveStatus = (status: number) => {
  const troveStatuses = Object.values(ETroveStatusGraph);

  if (status >= troveStatuses.length) return ETroveStatusGraph.NULL;

  return troveStatuses[status];
};

export async function getChainUserVault({
  assetAddress,
  userAddress,
  vaultManagerRead,
  interestManagerRead,
}: {
  assetAddress: AddressString;
  userAddress: AddressString;
  vaultManagerRead: TVaultManager['read'];
  interestManagerRead: TVestaInterestManager['read'];
}): Promise<GraphUserVault> {
  const [rawStatus, debt, collateral, [_, accumulatedInterest], unpaidInterest] = await Promise.all([
    vaultManagerRead.getTroveStatus([assetAddress, userAddress]),
    vaultManagerRead.getTroveDebt([assetAddress, userAddress]),
    vaultManagerRead.getTroveColl([assetAddress, userAddress]),
    interestManagerRead.getUserDebt([assetAddress, userAddress]),
    vaultManagerRead.getUnpaidInterestOfUser([assetAddress, userAddress]),
  ]);

  const status = findTroveStatus(Number(rawStatus));

  return {
    collateral: Number(formatEther(collateral)),
    debt: Number(formatEther(debt)),
    rawCollateral: collateral,
    rawDebt: debt,
    status: status.toString(),
    rawUnpaidInterest: unpaidInterest,
    unpaidInterest: Number(formatEther(unpaidInterest)),
    accumulatedInterest: Number(formatEther(accumulatedInterest)) || 0,
    rawAccumulatedInterest: accumulatedInterest,
  };
}
